import "./GchActivityStyles.css";
import PititionCollection from "../Assets/Activity/rohingya-1.jpg";
import GCH_Pitition from "../Assets/Activity/rohingya-2.jpg";
import GCHMedicineSp from "../Assets/Activity/rohingya-3.jpg";
import DrinkingWater1 from "../Assets/Activity/rohingya-4.jpg";
import DrinkingWater2 from "../Assets/Activity/rohingya-5.jpg";
import HurricaneMichael1 from "../Assets/Activity/HuricaneMichael-1.jpg";
import HurricaneMichael2 from "../Assets/Activity/HuricaneMichael-2.jpg";
import MotherLang1 from "../Assets/Activity/motherlang-1.jpg";
import MotherLang2 from "../Assets/Activity/motherlang-2.jpg";
import RetailSecurity1 from "../Assets/Activity/retailSecurity-1.jpg";
import RetailSecurity2 from "../Assets/Activity/retailSecurity-2.jpg";
import FoodDorian1 from "../Assets/Activity/dorian-1.jpg";
import FoodDorian2 from "../Assets/Activity/dorian-2.jpg";
import CoronaSupport1 from "../Assets/Activity/CoronaVirus-1.jpg";
import CoronaSupport2 from "../Assets/Activity/CoronaVirus-2.jpg";
import MentalHealth1 from "../Assets/Activity/healthAwareness-1.jpg";
import MentalHealth2 from "../Assets/Activity/healthAwareness-2.jpg";
import AntiPlastic1 from "../Assets/Activity/Anti-Plastic-1.jpg";
import AntiPlastic2 from "../Assets/Activity/Anti-Plastic-2.jpg";
import TurkeyEQ1 from "../Assets/Activity/TurkeyEarthQuake-1.jpg";
import TurkeyEQ2 from "../Assets/Activity/TurkeyEarthQuake-2.jpg";
// import GazaChildren1 from "../Assets/Activity/GazaHelp-1.jpg";
// import GazaChildren2 from "../Assets/Activity/GazaHelp-2.jpg";
import GazaChildren3 from "../Assets/Activity/GazaHelp-3.jpg";
function GchActivity() {
  return (
    <div className="activity-container">
      <h1>GCH Activities</h1>
      <p>Always beside the Humanity</p>
      <h2>Petition Signing and Fundraising for Rohingya Crisis</h2>
      <div className="rohingya-des">
        <div className="rohingya-text">
          <p>
            Due to the atrocity and armed conflict since August 2017 in Rakhine
            State of Myanmar, the Rohingya people fled and seek refugee across
            the border in Bangladesh. They are Muslim by religion and the
            military ruler of Myanmar denied their citizenship. After entering
            Myanmar, the Bangladesh Government accepted them as refugee and
            extended all out support in the southern part of the country in Coxs
            Bazar district. GCH, being a humanitarian organization, raised their
            voice for humanity. They collected petition from thousands of the
            peoples the community to submit to congress man for further action
            against Myanmar ruler. In this process most of the people in South
            Florida willingly signed our petition to support this noble cause
            against military rulers in Myanmar.
          </p>
        </div>
        <div className="rohingya-image">
          <img alt="img" src={PititionCollection} />
        </div>
      </div>

      <h2 className="pitition-header" center>
        Petition Submission
      </h2>
      <div className="pitition-des">
        <div className="pitition-image">
          <div>
            <img alt="img" src={GCH_Pitition} />
          </div>
        </div>
        <div className="pitition-text">
          <p>
            After collection of signatures from the community people in the
            petition to do justice with the Rohingya refugees in Bangladesh,
            members of Global Citizens for Humanity along with community leaders
            contacted the local Congressman Ted Deutch and Congresswomen Lois
            Frankel of the 22nd Congressional district of Florida. The
            congressional district office gladly accepted the petition and
            raised their voice in US Congress against military atrocity of
            Myanmar dictators. Later on, a resolution was passed in 116th US
            congress expressing the sense of the Senate that the Governments of
            Burma and Bangladesh ensure the safe, dignified, voluntary, and
            sustainable return of the Rohingya refugees who have been displaced
            by the campaign of ethnic cleansing conducted by the Burmese
            military.
          </p>
        </div>
      </div>
      <h2 className="rohingya-header" center>
        Medicine Support to Rohingya
      </h2>
      <div className="rohingya-des">
        <div className="rohingya-text">
          <p>
            Donating medicine to Rohingya Refugees was the first activities of
            Global Citizens for Humanity with the help of Bangladesh Army. GCH
            members collected funds from their own members and donated medicine
            for about 350,000.00 Taka. The medicine was purchased from
            Bangladesh and coordination was done with Bangladesh Army medical
            team in Cox's Bazar area. Before purchasing the medicine for the
            Rohingya refugees, GCH consulted with the local healt agencies in
            Cox's Bazar district and identified the most necessary medicines.
            Accordingly contacted with the most quality pharmacitucle companies
            in Bangladesh. After purchase, medicines were handed over to
            Bangladesh Army medical camp for appropriate prescription and
            distribution. GCH members were always vigilent throughout the
            process.
          </p>
        </div>
        <div className="rohingya-image">
          <img alt="img" src={GCHMedicineSp} />
        </div>
      </div>

      <h2 className="pitition-header" center>
        Drinking Water for Rohingya
      </h2>
      <div className="pitition-des">
        <div className="pitition-image">
          <div>
            <img alt="img" src={DrinkingWater1} />
          </div>
        </div>
        <div className="pitition-image-1">
          <div>
            <img alt="img" src={DrinkingWater2} />
          </div>
        </div>
        <div className="pitition-text">
          <p>
            Besides the health issues, drinking water supply was another
            important issue for Rohingya Refugees, especially the children. GCH
            came forward to arrange safe drinking water in limited scale within
            their capacity. President of GCH personally visited the camp and
            extended the required help to the need in terms of drinking water.
          </p>
        </div>
      </div>

      <h2 className="rohingya-header" center>
        Assistance to Hurricane Michael Victims
      </h2>
      <div className="hurricane-des">
        <div className="hurricane-michael">
          <div className="hurricane-text">
            <p>
              Major Hurricane Michael was the 13th named storm of the 2018
              Atlantic Hurricane Season. So far, there have been 15 named storms
              during the 2018 Atlantic Hurricane Season - 7 tropical storms and
              8 hurricanes. Two of those eight hurricanes strengthened into a
              major hurricane: Florence and Michael. It was the strongest
              hurricane on record to make landfall in the Florida panhandle with
              maximum sustained wind of 160 mph and a minimum pressure of 919
              mb.
            </p>
            <p>
              GCH immediately responded and stood beside affected people with
              generous donations from all members of the organization. To
              effectively help the need, the donation was sent to the affected
              people with the help of American Red Cross.
            </p>
          </div>
          <div className="hurricane-image-1">
            <img alt="img" src={HurricaneMichael1} />
          </div>
        </div>

        <div className="hurricane-image-2">
          <img alt="img" src={HurricaneMichael2} />
        </div>
      </div>
      <h2 className="pitition-header" center>
        Organizing International Mother's Language Day-2019
      </h2>
      <div className="pitition-des">
        <div className="pitition-image">
          <div>
            <img alt="img" src={MotherLang1} />
          </div>
        </div>
        <div className="pitition-image-1">
          <div>
            <img alt="img" src={MotherLang2} />
          </div>
        </div>
        <div className="pitition-text">
          <p>
            International Mother's Language Day is one of the significant events
            for Bengali speaking people. With the help of Palm Beach Sherif and
            ABPAC - Global Citizens for Humanity organized an event where
            children were focused to learn the importance of mother language for
            a nation. The whole program was financed by members of GCH.
          </p>
        </div>
      </div>
      <h2 className="rohingya-header" center>
        Retail Security Awareness Training
      </h2>
      <div className="rohingya-des">
        <div className="rohingya-text">
          <p>
            For a long time, the community peoples in retail business had been
            suffering from security in their profession. Lot of unpleasant
            incidents were happening where they could not take any actions due
            to lack of knowledge and opportunity to learn about it. Finally,
            Plam Beach Sherief Department came forward to train the retail store
            professionals.
          </p>
        </div>
        <div className="retailSecurity-image-1">
          <img alt="img" src={RetailSecurity1} />
        </div>
        <div className="retailSecurity-image-2">
          <img alt="img" src={RetailSecurity2} />
        </div>
      </div>
      <h2 className="pitition-header" center>
        Food Aid to Bahama After Hurricane Dorian
      </h2>
      <div className="pitition-des">
        <div className="pitition-image">
          <div>
            <img alt="img" src={FoodDorian1} />
          </div>
        </div>
        <div className="pitition-image-1">
          <div>
            <img alt="img" src={FoodDorian2} />
          </div>
        </div>
        <div className="pitition-text">
          <p>
            Hurricane Dorian was an extremely powerful and catastrophic Category
            5 Atlantic hurricane, which became the most intense tropical cyclone
            on record to strike the Bahamas on 24 August 2019. GCH immediately
            responded to the need of Bahama people with dry food and important
            grocery items.
          </p>
        </div>
      </div>
      <h2 className="rohingya-header" center>
        Health Awareness During Covid-19
      </h2>
      <div className="rohingya-des">
        <div className="rohingya-text">
          <p>
            COVID-19 was one of the largest challenges to humanity. GCH members
            actively stood beside the affected people by providing support in
            the form of tele medicine, food support and awareness programs. GCH
            telecasted VDOs that helped to protect themselves against COVID.
          </p>
        </div>
        <div>
          <a href="https://www.youtube.com/watch?v=ANrvweH-RZE" target="_blank">
            <img
              id="corona-support-image-1"
              alt="corona-vdo"
              src={CoronaSupport1}
            />
          </a>
        </div>
        <div>
          <a
            href="https://www.youtube.com/watch?v=oOOwJHLUKVY&t=152s"
            target="_blank"
          >
            <img
              id="corona-support-image-2"
              alt="corona-vdo"
              src={CoronaSupport2}
            />
          </a>
        </div>
      </div>
      <h2 className="pitition-header" center>
        Seminars on Mental Health
      </h2>
      <div className="pitition-des">
        <div>
          <a href="https://www.youtube.com/watch?v=DgY91FiyXtg" target="_blank">
            <img
              id="corona-support-image-1"
              alt="corona-vdo"
              src={MentalHealth1}
            />
          </a>
        </div>
        <div>
          <a href="https://www.youtube.com/watch?v=DgY91FiyXtg" target="_blank">
            <img
              id="corona-support-image-2"
              alt="corona-vdo"
              src={MentalHealth2}
            />
          </a>
        </div>

        <div className="pitition-text">
          <p>
            Mental health for children is one of the most concerned areas for
            the parents in the global community. Accordingly, GCH organized
            seminars with the expertise from different locations who identified
            the main reasons of mental illness and possible responses for the
            parents in the world.
          </p>
        </div>
      </div>
      <h2 className="rohingya-header" center>
        Anti Plastic Campaign
      </h2>
      <div className="rohingya-des">
        <div className="rohingya-text">
          <p>
            The Anti Plastic Campaign was organized to create awareness among
            the public about the adverse effect of plastic usage and to make
            think them about stopping its usage. As part of the campaign, on
            December 11, 2021, GCH successfully arranged cleaning Phipps Ocean
            Park and Beach in Palm Beach with the help of students and
            volunteers. This is an ongoing process which GCH arranges once or
            twice a year. It is one of our very successful projects. This beach
            cleaning process is organized mostly on Sundays or any holidays when
            the GCH members are normally off from their professional duties.
          </p>
        </div>
        <div className="retailSecurity-image-1">
          <img alt="img" src={AntiPlastic1} />
        </div>
        <div className="retailSecurity-image-2">
          <img alt="img" src={AntiPlastic2} />
        </div>
      </div>
      <h2 className="pitition-header" center>
        Assistance to Turkey Earthquakes
      </h2>
      <div className="pitition-des">
        <div className="pitition-image">
          <div>
            <img alt="img" src={TurkeyEQ1} />
          </div>
        </div>
        <div className="pitition-image-1">
          <div>
            <img alt="img" src={TurkeyEQ2} />
          </div>
        </div>
        <div className="pitition-text">
          <p>
            On 06 February 2023 a 7.8 Mw earthquake struck southern and central
            Turkey and northern and western Syria and caused widespread damage
            and fatalities to thousands of the peoples. GCH immediately
            responded to humanity and donated almost tents spending about 10
            thousand US Dollar. The tents were sent to Turkey using Turkish
            Aitlines.
          </p>
        </div>
      </div>

      <h2 className="rohingya-header" center>
        Assistance to Childrens in Gaza
      </h2>
      {/* <div className="gaza-des"> */}
      <div className="gaza-help">
        {/* <div className="gaza-text"> */}
        <p>
          The Israeli-Palestinian conflict is over who gets what land and how
          it's controlled. Though both Jews and Arab Muslims date their claims
          to the land back a couple thousand years, the current political
          conflict began in the early 20th century. Recently an armed conflict
          between Israel and Hamas-led Palestinian militant groups has been
          taking place chiefly in and around the Gaza Strip since 7 October
          2023, with clashes also taking place in the West Bank and
          Israel-Lebanon border.
        </p>
        <p className="gaza-para-1">
          GCH is always beside humanity. Accordingly, GCH members donated funds
          and sent them to assist the children in Gaza through UNICEF.
        </p>
        {/* </div> */}
        {/* <div className="gaza-image">
            <img alt="img" src={GazaChildren1} />
          </div>
          <div className="gaza-image-1">
            <img alt="img" src={GazaChildren2} />
          </div> */}
      </div>

      <div className="gaza-image-2">
        <img alt="img" src={GazaChildren3} />
      </div>
      {/* </div> */}
    </div>
  );
}

export default GchActivity;
